import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import da from "@/locales/da.json";
import en from "@/locales/en.json";

const initialLanguage =
  typeof document !== "undefined" ? document.documentElement.lang || "da" : "da";

i18n.use(initReactI18next).init({
  showSupportNotice: false,
  resources: {
    da: { translation: da },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: "da",
  initImmediate: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
